import React, { useEffect, useState } from 'react';

import { useVirtualRoom } from '../../../data/hooks/ui/useVirtualRoom';
import { useExternalURL } from '../../../data/hooks/ui/useExternalURL';

const VirtualRoomFrame = (props) => {
    const url = useExternalURL(),
        virtualRoom = useVirtualRoom(),
        [initialURL, setInitialURL] = useState(url);

    // change url if virtualRoom reference changes
    useEffect(() => {
        setInitialURL(url);
    }, [virtualRoom]);

    // unmaximize sidepanel on close
    useEffect(
        () => () =>
            app.store.dispatch(app.actions.ui.sidePanel.maximize(false)),
        []
    );

    return (
        <iframe
            className="VirtualRoomFrame"
            src={initialURL}
            allow="camera;microphone;display-capture;autoplay;encrypted-media;gyroscope"
        />
    );
};

export default VirtualRoomFrame;
